import request from "@/utils/request";
//注册
export const register = (data) => {
  return request({
    url: "/index.php/api/website/register",
    method: "post",
    data,
  });
};
//登陆
export const login = (data) => {
  return request({
    url: "/index.php/api/website/login",
    method: "post",
    data,
  });
};
// 个人资料
export const getUserinfo = (token) => {
  return request({
    url: "/index.php/api/website/getUserinfo",
    method: "get",
    params: { token },
  });
};
//完善资料
export const saveUserinfo = (data) => {
  return request({
    url: "/index.php/api/website/saveUserinfo",
    method: "post",
    data,
  });
};
//保存定制人物
export const insertuploadpsds = (data) => {
  return request({
    url: "/index.php/api/website/insertuploadPsd",
    method: "post",
    data,
  });
};
//首页
export const index = () => {
  return request({
    url: "/index.php/api/website/index",
    method: "get",
  });
};
//分类列表
export const getsortData = () => {
  return request({
    url: "/index.php/api/website/getsortData",
    method: "get",
  });
};
//素材列表
export const getData = (params) => {
  return request({
    url: "/index.php/api/website/getData",
    method: "get",
    params,
  });
};
//下载素材
export const downData = (params) => {
  return request({
    url: "/index.php/api/website/downData",
    method: "get",
    params,
  });
};
//下载模型
export const downModel = (params) => {
  return request({
    url: "/index.php/api/website/down_model",
    method: "get",
    params,
  });
};
//退出
export const logut = (params) => {
  return request({
    url: "/index.php/api/website/logut",
    method: "post",
    params,
  });
};
//获取其他信息
export const peizhi = () => {
  return request({
    url: "/index.php/api/website/other_accessory",
    method: "get",
  });
};
